import { render, staticRenderFns } from "./admin-request-history.vue?vue&type=template&id=e36515e0&"
import script from "./admin-request-history.vue?vue&type=script&lang=js&"
export * from "./admin-request-history.vue?vue&type=script&lang=js&"
import style0 from "./admin-request-history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports